import { Subject } from "rxjs";

export type EntityLiveUpdateEvent = {
  type: "subscription_update" | "quota_update";
};

export const entityLiveUpdates$ = new Subject<EntityLiveUpdateEvent>();
